export default __webpack_public_path__ + "static/media/stats.478771aa.svg";